import { create } from "zustand";

interface SidebarState {
  isFloating: boolean;
  isSidebarVisible: boolean;
  isCollapsed: boolean;
  setIsFloating: (floating: boolean) => void;
  setIsSidebarVisible: (visible: boolean) => void;
  setIsCollapsed: (collapsed: boolean) => void;
  detachAndCollapse: () => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
  isFloating: false,
  isSidebarVisible: false,
  isCollapsed: false,
  setIsFloating: (floating) => set({ isFloating: floating }),
  setIsSidebarVisible: (visible) => set({ isSidebarVisible: visible }),
  setIsCollapsed: (collapsed) => set({ isCollapsed: collapsed }),
  detachAndCollapse: () =>
    set({ isFloating: true, isSidebarVisible: false, isCollapsed: true }),
}));
